export const DIALOG_POSITIONER =
    "fixed inset-0 h-[100dvh] z-50 bg-m-grey-900 safe-top safe-bottom";
export const DIALOG_CONTENT =
    "h-full flex flex-col justify-between px-4 pt-4 pb-8 bg-m-grey-900 touch-manipulation select-none overflow-y-scroll disable-scrollbars";
